<template>
  <DBox
    :id="'cmp-booking-booking-booking_sidewindow-custom-checklist'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('task')}`"
    @add_click="openAddTaskModal"
  >
    <div class="dt-list" v-if="task_checklist">
      <div
        class="dt-list-item"
        v-for="task of task_checklist"
        :key="task.checklist_id"
      >
        <div class="dt-list-item--body">
          <div class="dt-list-item--text">{{ task.name }}</div>
          <div v-if="task.is_done === '1'" class="dt-list-item--text">
            {{ task.user_name }} {{ task.timestamped.split(" ")[0] }}
          </div>
        </div>
        <div class="dt-list-item--options ut-colcen">
          <div class="dt-checkbox v2 s1">
            <input
              type="checkbox"
              :name="task.name"
              :id="task.name"
              :checked="task.is_done == '1'"
              @click="(e) => onCheckboxChange(e, task)"
            />
            <div class="checkmark"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="dbox-title-bar--options">
      <img @click="openAddTaskModal" src="static/icons/add-icon.svg" class="dt-icon v4" alt />
      <div class="button add-button">
        <div class="dt-icon-container">
          <img @click="openAddTaskModal" src="static/icons/add.svg" class="dt-icon" alt="">
        </div>
      </div>
    </div> -->
  </DBox>
</template>

<script>
import AddChecklist from "../../../../dt-plugins/custom-checklist/add-checklist";
import EditChecklist from "../../../../dt-plugins/custom-checklist/edit-checklist";

export default {
  components: {
    AddChecklist,
    EditChecklist,
  },
  props: ["booking"],
  data: function () {
    return {
      addDialog: false,
      editDialog: false,
    };
  },
  computed: {
    task_checklist: function () {
      return this.booking?.task_checklist || [];
    },
    calendarDateId: function () {
      return this.booking?.cdate?.calendar_date_id;
    },
  },
  methods: {
    log: function (event) {
      console.log(event);
    },
    openAddTaskModal: function () {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, modal: "add_task" },
      });
    },
    onCheckboxChange(e, task) {
      if (e.target.checked) {
        this.$emit("complete", {
          calendarDateId: this.calendarDateId,
          task,
        });
      } else {
        this.$emit("undo", {
          calendarDateId: this.calendarDateId,
          task,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dt-list {
  .dt-list-item {
    padding: 6px 10px;
    font-size: 13px;
    color: var(--icolr-1);

    display: flex;

    &:not(:last-child) {
      border-bottom: 1px solid var(--sprt-10);
    }

    &--body {
      flex: 1;
    }
    &--options {
      max-width: 10px;
    }
  }
}
</style>
